// This file is auto-generated. Do not edit manually.
export const VERSION = {
  date: "2026-05-17T18:40:04.808Z",
  commit: "c8f155852476f05070361275bd7f8b1d802c7005",
} as const;

export type Version = typeof VERSION;
